export default "__VITE_ASSET__CaARUzKB__"